import type {FC} from 'react';

import {HeaderDraft} from './draft';
import {HeaderServer} from './server';

interface Props {
	isDraft: boolean;
}

export const Header: FC<Props> = ({isDraft}) => {
	return isDraft ? <HeaderDraft /> : <HeaderServer />;
};
